exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main